<template>
  <teleport to="#modalTeleport">
    <ReceptionModal ref="receptionModal"></ReceptionModal>
  </teleport>
  <HeadlineComponent>Empfang</HeadlineComponent>
  <div class="mb-5" v-if="events.length > 1">
    <label for="event_select">Veranstaltung Auswählen</label>
    <select id="event_select" v-model="event_id" class="form-control">
      <option>--- Auswählen ---</option>
      <option v-for="e of events" :key="e.id" :value="e.id">
        {{ e.name }}
      </option>
    </select>
  </div>
  <Form class="form-horizontal" @submit="search" ref="form">
    <div class="form-group">
      <BootstrapField
        type="text"
        placeholder="Token"
        name="token"
        autofocus="autofocus"
        ref="token"
        rules="uuid"
      />
    </div>
    <div class="form-group">
      <BootstrapField
        type="text"
        placeholder="Vorname"
        name="first_name"
        rules="min:3"
      />
    </div>
    <div class="form-group">
      <BootstrapField
        type="text"
        placeholder="Nachname"
        name="last_name"
        rules="min:3"
      />
    </div>
    <div class="form-group">
      <BootstrapField
        type="text"
        placeholder="Gruppe"
        name="group"
        rules="min:3"
      />
    </div>
    <div class="form-group">
      <LoadingButton class="btn-light" :loading="searchLoading"
        >Suchen</LoadingButton
      >
    </div>
  </Form>

  <div class="table-responsive text-center">
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Angekommen</th>
          <th>Name</th>
          <th>Typ</th>
          <th>T-Shirt Größe</th>
          <th>Hat Shirt</th>
          <th>Gruppe</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="ticket of tickets" :key="ticket.id">
          <td v-if="ticket.has_arrived"><span class="fa fa-check"></span></td>
          <td v-if="!ticket.has_arrived">
            <a href="#" @click.prevent="arrive(ticket)"
              ><span class="fa fa-remove"></span
            ></a>
          </td>
          <td>{{ ticket.full_name }}</td>
          <td>{{ ticket.type }}</td>
          <td>{{ $filters.shirtSizeName(ticket.shirt_size) }}</td>
          <td v-if="ticket.has_shirt"><span class="fa fa-check"></span></td>
          <td v-if="!ticket.has_shirt">
            <span class="fa fa-remove" v-if="ticket.shirt_size"></span>
          </td>
          <td>{{ ticket.group }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import HeadlineComponent from "../components/HeadlineComponent.vue";
import { Form } from "vee-validate";
import BootstrapField from "@/components/BootstrapField.vue";
import { mapActions } from "pinia";
import { useAlertsStore } from "../stores/alerts.js";
import ReceptionModal from "../components/ReceptionModal.vue";
import receptionService from "../services/reception.service.js";
import LoadingButton from "../components/LoadingButton.vue";
import eventService from "../services/event.service";
import * as Sentry from '@sentry/vue';

export default {
  name: "ReceptionView",
  components: {
    LoadingButton,
    ReceptionModal,
    HeadlineComponent,
    // eslint-disable-next-line vue/no-reserved-component-names
    Form,
    BootstrapField,
  },
  data() {
    return {
      tickets: [],
      searchLoading: false,
      events: [],
      event_id: "",
    };
  },
  mounted() {
    this.$refs.token.focus();
  },
  async beforeRouteEnter(to, from, next) {
    let events = [];
    try {
      let response = await eventService.index(false);
      events = response.data;
    } catch (e) {
      if (e) {
        Sentry.captureException(e);
        useAlertsStore().add(
          "danger",
          "Es ist was unerwartetes schief gegangen.."
        );
        window.scrollTo(0, 0);
      }
    }
    next((vm) => {
      vm.events = events;
      if (events.length) {
        if (to.query.event_id) {
          vm.event_id = to.query.event_id;
        } else {
          vm.event_id = events[0].id;
        }
      }
    });
  },
  methods: {
    ...mapActions(useAlertsStore, { addAlert: "add" }),
    async arrive(ticket) {
      try {
        let response = await receptionService.arrive(
          this.event_id,
          ticket.ticket_id
        );
        await this.$refs.receptionModal.show(response.data);
        this.resetForm();
      } catch (e) {
        if (e) {
          this.addAlert("danger", e.response.data.message);
          window.scrollTo(0, 0);
        }
      }
    },
    async search(form) {
      this.searchLoading = true;
      try {
        let response = await receptionService.index(this.event_id, form);
        this.tickets = response.data;
        if (response.data.length === 0) {
          this.addAlert("danger", "Keine passenden Tickets gefunden");
        }
        this.token = "";
        this.searchLoading = false;
      } catch (e) {
        if (e) {
          Sentry.captureException(e);
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
        this.searchLoading = false;
      }
    },
    resetForm() {
      this.tickets = [];
      this.$refs.form.resetForm();
      this.$refs.token.focus();
    },
  },
};
</script>

<style scoped>
.form-horizontal {
  width: 100%;
  max-width: 330px;
  margin: 0 auto;
  padding: 15px;
}

.form-group {
  text-align: center;
}
</style>
